/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FinalReviewParticipant { 
    readonly id: number;
    code: string;
    name: string;
    surname: string;
    fullName: string;
    email?: string;
    checked?: boolean;
    status?: FinalReviewParticipantStatusEnum;
    reason?: string;
}
export enum FinalReviewParticipantStatusEnum {
    Enabled = 'enabled',
    InProgress = 'in_progress',
    Passed = 'passed',
    Failed = 'failed'
};



